let API = "/api/v2";

if(process.env.NODE_ENV !== "production")
  API = "http://localhost:4000/api/v2";

export default API;
